import React from 'react';
import { Route } from 'react-router-dom';
import { HOME } from './paths';
import Home from 'modules/Home';
function HomeRoutes() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: HOME
  }, /*#__PURE__*/React.createElement(Home, null)));
}
export default HomeRoutes;